import { Recorder } from '../../entities/recorder';
import { TimelineStore } from '../../timeline/timeline.store';
import { Player } from '../../entities/player';
import { RecorderStore } from '../../stores/recorder.store';
var RecordButtonsComponent = /** @class */ (function () {
    function RecordButtonsComponent(timelineStore, recorderStore, recorder, player) {
        this.timelineStore = timelineStore;
        this.recorderStore = recorderStore;
        this.recorder = recorder;
        this.player = player;
        this.repeat = false;
    }
    RecordButtonsComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(RecordButtonsComponent.prototype, "undoButtonDisabled", {
        get: function () {
            return this.player.playback ||
                this.recorder.recording ||
                this.recorderStore.historyData.appliedTransactionsNumber === 0;
        },
        enumerable: true,
        configurable: true
    });
    RecordButtonsComponent.prototype.onUndoButtonClick = function () {
        this.recorderStore.undo();
    };
    Object.defineProperty(RecordButtonsComponent.prototype, "redoButtonDisabled", {
        get: function () {
            return this.player.playback ||
                this.recorder.recording ||
                this.recorderStore.historyData.rollbackTransactionsNumber === 0;
        },
        enumerable: true,
        configurable: true
    });
    RecordButtonsComponent.prototype.onRedoButtonClick = function () {
        this.recorderStore.redo();
    };
    RecordButtonsComponent.prototype.onRepeatButtonClick = function () {
        this.repeat = !this.repeat;
    };
    Object.defineProperty(RecordButtonsComponent.prototype, "repeatButtonIsDisabled", {
        get: function () {
            return this.player.playback ||
                this.recorder.recording;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordButtonsComponent.prototype, "playback", {
        get: function () {
            return this.player.playback;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordButtonsComponent.prototype, "playbackButtonIsDisabled", {
        get: function () {
            return this.recorderStore.recordData.length === 0 || this.recorder.recording;
        },
        enumerable: true,
        configurable: true
    });
    RecordButtonsComponent.prototype.onPlaybackButtonClick = function () {
        this.togglePlayback();
    };
    RecordButtonsComponent.prototype.togglePlayback = function () {
        if (this.player.playback) {
            this.player.stop();
        }
        else {
            this.player.play(this.playbackConfig);
        }
    };
    Object.defineProperty(RecordButtonsComponent.prototype, "playbackConfig", {
        get: function () {
            var currentPosition = this.timelineStore.currentPosition;
            var recordLength = this.recorderStore.recordData.length;
            var startPosition = currentPosition < recordLength ? currentPosition : 0;
            var endPosition = recordLength;
            var repeat = this.repeat;
            return { startPosition: startPosition, endPosition: endPosition, repeat: repeat };
        },
        enumerable: true,
        configurable: true
    });
    RecordButtonsComponent.prototype.onRecordingButtonClick = function () {
        this.toggleRecording();
    };
    Object.defineProperty(RecordButtonsComponent.prototype, "recordingButtonIsDisabled", {
        get: function () {
            return this.player.playback;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordButtonsComponent.prototype, "recording", {
        get: function () {
            return this.recorder.recording;
        },
        enumerable: true,
        configurable: true
    });
    RecordButtonsComponent.prototype.toggleRecording = function () {
        this.recording ? this.stopRecording() : this.startRecording();
    };
    RecordButtonsComponent.prototype.startRecording = function () {
        this.recorder.startRecording(this.timelineStore.recordingConfig);
    };
    RecordButtonsComponent.prototype.stopRecording = function () {
        this.recorder.stopRecording();
    };
    return RecordButtonsComponent;
}());
export { RecordButtonsComponent };



// WEBPACK FOOTER //
// ./src/app/rec/components/record-buttons/record-buttons.component.ts.pre-build-optimizer.js